import React, { FC } from 'react';
import { SystemButtonHyperlinkProps } from '../button.types';
import { Hyperlink } from '../../Hyperlink';
import { SystemHyperlinkDefault } from '../systemButtonDefaultProps';
import { SystemButtonContent } from '../SystemButton';
import styles from './primary_button.module.scss';

type Props = {
  iconLeft?: string;
  iconRight?: string;
} & SystemButtonHyperlinkProps;

export const PrimaryHyperlink: FC<Props> = ({
  children,
  source,
  iconLeft,
  iconRight,
  ...hrefProps
}) => {
  return (
    <Hyperlink {...hrefProps} className={styles.primary} source={source}>
      <SystemButtonContent iconLeft={iconLeft} iconRight={iconRight}>
        {children}
      </SystemButtonContent>
    </Hyperlink>
  );
};

PrimaryHyperlink.defaultProps = SystemHyperlinkDefault;
